module.exports = __webpack_public_path__ + "static/media/06.Stage Setpup.4e800dc0.JPG";